
export function loadShortNamesListAsPromise(
    server:        string,
    regionId:      string,
    locale:        string,
    pageSeoString: string
): Promise<any> {
    const fetchUrl = '/share/epSnow/epSnowGetShortNamesAsJson.php';
    const fetchOptions = {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({server: server, regionId: regionId, locale: locale, pageSeoString: pageSeoString})
    };

    return fetch(fetchUrl, fetchOptions as RequestInit);
}